<div
  appThrottleClick
  (throttleClick)="navItemSelected()"
  [attr.data-testid]="navItem | navItemTestId"
  [class.active]="viewModel.isNavItemActive$ | async"
  [class.animating]="animating$ | async"
  [ngbTooltip]="collapsed ? navItem.name : null"
  [placement]="'right'"
  class="nav-item active bs-nav-item passive-selection"
  fxLayout="row"
  fxLayoutAlign="center center">
  <div fxFlex class="current-loc-nav-item-container">
    <div class="nav-item-icon">
      <img [src]="navItem.iconSrc" alt="icon" class="nav-bar-icon" />
      <img [src]="navItem.iconFilledSrc" alt="icon-filled" class="nav-bar-icon-filled" />
    </div>
    <div
      *rxIf="!collapsed"
      class="nav-item-label"
      fxFlex
      [class.multi-line-label]="viewModel.multiLineNavItem$ | async">
      {{ viewModel.location$ | async }}
    </div>
  </div>
  <img *rxIf="!collapsed" alt="icon" class="nav-bar-icon" src="/assets/icons/light/outline/selector.svg" />
</div>
